export default __webpack_public_path__ + "static/media/email.d30b64f4.svg";